import * as React from 'react';

import { useForm, FormProvider } from 'react-hook-form';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';

type Option = {
  label: string;
  value: string;
};


type Props = {
  options: Option[];
  placeholder: string;
  value: Option[] | undefined;
  setValue: (value: Option[]) => void;
};

export function ChipsAutocomplete({
  options,
  placeholder,
  value,
  setValue,
}: Props) {
  const methods = useForm({
    defaultValues: {
      metaKeywords: [],
    },
  });

  return (
    <Box sx={{ width: '100%' }}>
      <FormProvider {...methods}>
        <Autocomplete
          disableCloseOnSelect
          options={options}
          popupIcon={<CaretDown size={18} />}   
          disableClearable
          multiple
          getOptionLabel={(option: Option) => option.label}
          onChange={(event, newValue) => {
            setValue(newValue as Option[]);
          }}
          isOptionEqualToValue={(option: Option, v: Option) => option.value === v.value}
          value={value || []}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={value?.length === 0 ? placeholder : ''}
              size="small"
            />
          )}
          slotProps={{
            chip: { color: 'primary', size: 'small' },
            popper: {
              sx: {
                '& .MuiAutocomplete-option': {
                  margin: '4px 0 !important',
                  fontSize: '16px !important',
                },
              },
            },
            paper: {
              sx: {
                fontSize: "16px !important",
              },
            },
          }}
          sx={{
            width: '100%',
            "& .MuiInputBase-input": {
							cursor: "pointer",
							fontSize: "16px",
						},
          }}
        />
      </FormProvider>
    </Box>
  );
}
